<template>
    <div class="xcard">
        <h4 class="text-center">Usuarios Registrados con Acceso al Sistema</h4>
        <div class="row">
            <div class="col-sm-6">
                <input type="text" class="form-control" v-model="buscar" placeholder="Buscar usuario">
            </div>
            <div class="col-sm-6 text-right">
                <button v-show="usuarios.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')"> <span class="glyphicon glyphicon-print"></span> Generar Reporte EXCEL </button>
                <router-link to="usuarioadd" v-show="(!$store.state.isonlyread && $store.state.createUsuario && espermitido) || isCCA" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-user"></span> Nuevo usuario</router-link>
            </div>
        </div>

        <p class="text-primary"> {{usuarios.length}} usuarios. </p>

        <table ref="table" class="table table-condensed table-striped table-hover" id="midatatable" summary="lorem ipsum sit amet" rules="groups" frame="hsides">
            <caption v-show="false">Reporte de Usuarios: </caption>
            
            <thead style="background:#196391;">
                <tr class="white--text">
                    <th>No</th>
                    <th>Documento</th>
                    <th>Nombres y Apellidos</th>
                    <!-- <th>Usuario</th> -->
                    <th>Cargos</th>
                    <th>Residencia</th>
                    <th>Estado</th>
                    <th>Opciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-bind:key="p.id" v-for="(p,ind) in usuarios">
                    <td> {{ind+1}} </td>
                    <td :title="p.usuario.id"> {{parseDoc(p.usuario.datos_personales)}} </td>
                    <td :class="parseEstadoColor2(p.usuario)"> {{parseDatos(p.usuario.datos_personales)}} </td>
                    <!-- <td> {{p.usuario.login}} </td> -->
                    <td> {{parseCargos(p.usuario)}} </td>
                    <td> {{parseCiudad(p.usuario.datos_personales)}} </td>
                    <td :class="parseEstadoColor(p.usuario)"> {{parseEstado(p.usuario)}} </td>
                    <td>
                        <button v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 8" class="btn btn-sm btn-default" @click="modificar(p.usuario)"> <span class="glyphicon glyphicon-pencil"></span> </button>
                        <button v-if="($store.state.CARGO.id == 1 || $store.state.CARGO.id == 8) && p.usuario.estado"  @click="showEliminar(p.usuario.id)" data-toggle="modal" data-target="#modal" title="Cambiar Estado" class="btn btn-sm btn-default"> <span class="glyphicon glyphicon-trash"></span> </button>
                        <button v-if="($store.state.CARGO.id == 1 || $store.state.CARGO.id == -8) && p.usuario.estado==false"  @click="showEliminar(p.usuario.id)" data-toggle="modal" data-target="#modal" title="Cambiar Estado" class="btn btn-sm btn-default"> <span class="glyphicon glyphicon-arrow-up"></span> </button>
                        <button v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 8"  @click="cambiarDatos(p.usuario)" title="Cambiar Datos de Acceso" class="btn btn-sm btn-default"> <span class="glyphicon glyphicon-lock"></span> </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito"/>
        <notifications group="auth" position="bottom right" />
        <Alertas ref="alertar" />
    </div>
</template>

<script>
import gql from 'graphql-tag'
import Alertas from '@/components/AAlertas.vue'
import modal from '@/components/AEstado.vue'
import {parseJsonError} from '@/components/Utils.js'
export default {
    data(){
        return{
            // EXCEL 
            uri :'data:application/vnd.ms-excel;base64,',
            template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
            format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
            // END EXCEL 
            buscar: '',
            seleccionado: {xid:-1,xtitle:'X',xbody:'X',xsql:null},
            usuarios: [],
            espermitido: false,
            isCCA: false,
        }
    },
    watch: {
        '$store.state.CARGO':function(){
            this.usuarios = [];
            this.getUsuarios();
        },
        'buscar': function(){ this.myFunction1( this.buscar ) }
    },
    components:{ Alertas,modal },
    methods:{
        tableToExcel(table, name){
            if (!table.nodeType) table = this.$refs.table
            var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
            var link = document.createElement("a");
            link.download = "usuarios.xls";
            link.href = this.uri + this.base64(this.format(this.template, ctx));
            link.click();
        },
        parseCargos( u ){
            if( u == null ) return "0";
            if( u.cargos.length > 1 ) return "("+u.cargos.length+" cargos)";
            else{
                var str = "";
                u.cargos.forEach( function(e){ str += e.cargo.nombre });
                return str;
            }
        },
        parseCiudad( u ){
            if( u == null ) return "";
            if( u.ciudad != null ) return u.ciudad.nombre;
            return "";
        },
        parseDoc( u ){
            if( u == null ) return "";
            if( u.departamento != null ) return u.num_doc +" "+u.departamento.extension;
            return u.num_doc;
        },
        parseDatos( u ){
            if( u == null ) return "";
            if( u.seg_apellido == null ) u.seg_apellido = "";
            return u.nombres+" "+u.pri_apellido+" "+u.seg_apellido;
        },
        parseEstado( u ){
            if( u.estado ) return "Activo";
            else return "Inactivo";
        },
        parseEstadoColor( u ){
            if( u.estado ) return "text-success";
            else return "text-danger";
        },
        parseEstadoColor2( u ){
            if( u.estado ) return "";
            else return "text-danger";
        },
        modificar( u ){
            window.sessionStorage.setItem( 'xxusuario',JSON.stringify(u) );
            this.$router.push({name:'usuariomod'});
        },
        cambiarDatos( u ){
            window.sessionStorage.setItem( 'xxusuario',JSON.stringify(u) );
            this.$router.push({name:'datosaccesso'});
        },
        async getUsuarios() {
            var vue = this;
            var idsede = this.$store.state.CARGO.sede.id;
            if( idsede == null ){
                window.console.error( "Usuarios idsede NULL" )
                return;
            }
            this.$refs.alertar.cargando();
            var sql =gql`query{ getSede(id:${idsede}){usuarios_activos{usuario{id,estado,login,cargos{cargo{nombre},sede{nombre},desde},datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido,email,ciudad{id,nombre},departamento{id,nombre,extension}}}}} }`;
            await this.$apollo.query({
            query: sql,
            variables: { 
            },
            }).then((data) => {
                this.$refs.alertar.reset();
                var datos = data.data.getSede.usuarios_activos;
                var users = datos.filter( function(e){ return e.usuario.datos_personales.id != 1 });

                //users = datos.filter( function(e){ return e.usuario.datos_personales.id != 1 })
                users = users.sort( function(a,b){
                    var ae = a.usuario.estado?-1:1;
                    var be = b.usuario.estado?-1:1;
                    var n = (a.usuario.datos_personales.nombres < b.usuario.datos_personales.nombres)?-1:1;
                    return ae - be || n;
                })
                
                const uniqueArray = users.filter((thing, index) => {
                    const _thing = JSON.stringify(thing);
                        return index === users.findIndex(obj => {
                            return JSON.stringify(obj) === _thing;
                        });
                });
                vue.usuarios = uniqueArray;
                // window.console.log(vue.usuarios)
            }).catch((erro) => {
                this.$refs.alertar.invalido();
                // window.console.error(erro)
                this.$notify( parseJsonError( erro,'getSede' ) )
            })
        },
        modalExito(){
            this.getUsuarios();
            this.seleccionado.xid=null;
        },
        showEliminar( id ){
            var obj = this.usuarios.find( x => x.usuario.id==id );
            window.console.log( "jajajjjajajjajaajajaaj",obj,id )
            var msg = "Cambiar Estado";
            var estad = !obj.usuario.estado;
            var str = 'Inactivo';
            if( obj.usuario.estado ) str = 'Activo';
            var body = "El usuario '"+obj.usuario.datos_personales.nombres+", estado actual:"+str+"' sera cambiado.";
            var tag = gql`mutation{ cambiarEstadoUsuario(input:{id:${id},estado: ${estad}}){ok,errors{message}} }`;
            this.seleccionado = {xid:id,xtitle:msg,xbody:body,xsql:tag}

            // window.console.log( "VVVVVVVVVVVVVVVVVVVVVVVV",this.seleccionado,obj );
        },
        myFunction1( filtro ) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd,td, i,j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for(j = 1; j< tdd.length;j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    } 
                }
            }
		},
    },
    mounted(){
        let sedecca_tarija = this.$store.state.CARGO.sede.id;
        // eva yujra 
        this.isCCA = this.$store.state.DATA_USER.id == 6007 && sedecca_tarija == 10;
        let idcargo = this.$store.state.CARGO.id;
        this.espermitido = idcargo == 8 || idcargo == 1;
        this.getUsuarios();
    }
}
</script>